import DomComponent from 'App/lib/domComponent';
import { each } from 'App/lib/util';
import scroll from 'App/services/scroll';

export default class DropdownComponent extends DomComponent {
    static selector = '[data-js-dropdown]';
    isActive = false;
    activeClass = 'active';
    modalClickRef;

    constructor(el, context) {
        // return false
        super(el);

        if(!context) {
            context = document;
        }

        this.triggers = context.querySelectorAll(`[data-dropdown-trigger="${this.el.dataset.jsDropdown}"]`);

        document.body.appendChild(this.el);
        each(this.triggers, (trigger) => {
            // const style = getComputedStyle(trigger);

            // const anchor = trigger.getBoundingClientRect();
            // this.el.style.top = `${anchor.bottom}px`;

            trigger.addEventListener('click', (e) => {
                if(this.isActive) {
                    this.close();
                }else{
                    this.open(trigger);
                }
            })
        });

        this.el.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        setTimeout(() => {
            this.loaded();
        });
    }

    open(anchor) {

        // Variables.
        let layoutInterval,
            anchorPoint,
            lastTop,
            lastWidth;

        this.isActive = true;
        this.el.classList.add(this.activeClass);

        each(this.triggers, (trigger) => {
            trigger.classList.add(this.activeClass);
        });

        // Function to adjust the layout of the drop down (e.g., on scroll).
        let adjustLayout = () => {

            // Variables.
            anchorPoint = anchor.getBoundingClientRect();
            let anchorWidth = anchor.clientWidth,
                newTop = anchorPoint.bottom + window.pageYOffset;

            // Adjust top?
            if (newTop !== lastTop) {
                lastTop = newTop;
                this.el.style.top = `${newTop}px`;
            }

            // Adjust width.
            if (this.el.clientWidth < anchorWidth && anchorWidth !== lastWidth) {
                lastWidth = anchorWidth;
                this.el.style.width = `${anchorWidth}px`;
            }

            // Adjust left/right?
            if (anchorPoint.left + (anchor.clientWidth + this.el.clientWidth) / 2 >= window.innerWidth) {
                this.el.style.right = '0';
                this.el.style.left = 'auto';
            } else if (anchorPoint.left - (this.el.clientWidth - anchor.clientWidth) * 0.5 < 0) {
                this.el.style.left = '0';
                this.el.style.right = 'auto';
            } else {
                this.el.style.left = (anchorPoint.left - 0.5 * (this.el.clientWidth - anchor.clientWidth)) + 'px';
            }

            // Once the window is close, stop adjusting the layout.
            if (!this.isActive) {
                window.removeEventListener('scroll', adjustLayout);
                clearInterval(layoutInterval);
            }

        };

        // Adjust the drop down layout (on scroll, on an interval, and immediately). The scroll ensures the drop
        // down updates quickly. The interval ensures the drop down updates even in more exotic scenarios (e.g.,
        // scrolling the modal rather than the window).
        window.addEventListener('scroll', adjustLayout);
        layoutInterval = setInterval(adjustLayout, 200);
        adjustLayout();

        const rect = this.el.getBoundingClientRect();
        const bottomBound = anchorPoint.bottom + window.pageYOffset + rect.height + 20;
        const bottomWindow = window.innerHeight + window.pageYOffset;

        if(bottomWindow < bottomBound) {
            scroll.to(bottomBound - window.innerHeight, 300);
        }

        const event = new CustomEvent('dropdown:open');
        this.el.dispatchEvent(event);

        setTimeout(() => {
            document.onclick = this.close.bind(this);
            const modalBox = document.querySelector('[data-modal-box]');
            if(modalBox) {
                this.modalClickRef = this.close.bind(this);
                modalBox.addEventListener('click', this.modalClickRef);

            }
        });
    }

    close() {
        this.isActive = false;
        this.el.classList.remove(this.activeClass);

        each(this.triggers, (trigger) => {
            trigger.classList.remove(this.activeClass);
        });

        const event = new CustomEvent('dropdown:close');
        this.el.dispatchEvent(event);

        document.onclick = null;
        const modalBox = document.querySelector('[data-modal-box]');
        if(modalBox && this.modalClickRef) {
            modalBox.removeEventListener('click', this.modalClickRef);
        }
    }
}
